module.exports = __webpack_public_path__ + "static/img/two.5ac64a4e.png";